import type {BioIconProps} from './common-types'

export function EnvelopeIcon({fill = 'white', ...attributes}: BioIconProps) {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M14 3.59961H2C1.86739 3.59961 1.74021 3.65229 1.64645 3.74606C1.55268 3.83982 1.5 3.967 1.5 4.09961V12.5996C1.5 12.8648 1.60536 13.1192 1.79289 13.3067C1.98043 13.4943 2.23478 13.5996 2.5 13.5996H13.5C13.7652 13.5996 14.0196 13.4943 14.2071 13.3067C14.3946 13.1192 14.5 12.8648 14.5 12.5996V4.09961C14.5 3.967 14.4473 3.83982 14.3536 3.74606C14.2598 3.65229 14.1326 3.59961 14 3.59961ZM12.7144 4.59961L8 8.92148L3.28562 4.59961H12.7144ZM13.5 12.5996H2.5V5.23648L7.66187 9.96836C7.75412 10.053 7.87478 10.1 8 10.1C8.12522 10.1 8.24588 10.053 8.33813 9.96836L13.5 5.23648V12.5996Z"
        fill={fill}
      />
    </svg>
  )
}
